import axios from 'axios';
import { toast } from 'react-toastify';
export const GET_ROUTINE = "GET_ROUTINE";
export const GET_EXERCISE = "GET_EXERCISE";
export const GET_GENERAL_ROUTINE ="GET_GENERAL_ROUTINE"

const baseURL = process.env.REACT_APP_API_URL;

const httpRequest = async ({ method, url, data = null, message }) => {
    try {

        const config = {
            method,
            maxBodyLength: Infinity,
            url,
        };

        if (data) {
            config.data = data;
        }

        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        if (error.response?.status === 401) {
            toast.error("Unauthorized user", { theme: "colored", toastId: "id_error" });
            localStorage.clear();
            window.location.reload();
        } else {
            toast.error(message, { theme: "colored", toastId: "id_error" });
            console.error(error);
            throw error;
        }
    }
};


export const getRoutineByDay = (day) => {
    return async (dispatch) => {
        try {
            const data = await httpRequest({
                method: "get",
                url: `${baseURL}/routines?day=${day}`,
                message: "Error retrieving routine",
            });
            dispatch({ type: GET_ROUTINE, payload: data });
        } catch (error) {
            console.error("Error retrieving routine", error);
        }
    };
};

export const getGeneralRoutine = () => {
    return async (dispatch) => {
        try {
            const data = await httpRequest({
                method: "get",
                url: `${baseURL}/routines`,
                message: "Error retrieving general routine",
            });
            dispatch({ type: GET_GENERAL_ROUTINE, payload: data });
        } catch (error) {
            console.error("Error retrieving general routine", error);
        }
    };
};

export const getExcerciseById = (id) => {
    return async (dispatch) => {
        try {
            const data = await httpRequest({
                method: "get",
                url: `${baseURL}/exercises?id=${id}`,
                message: "Error retrieving exercise",
            });
            dispatch({ type: GET_EXERCISE, payload: data });
        } catch (error) {
            console.error("Error retrieving exercise", error);
        }
    };
};

export const createHistoryByExercise= (exerciseData) => {
    return async (dispatch) => {
        try {
            const data = await httpRequest({
                method: "post",
                url: `${baseURL}/historys`,
                data: exerciseData,
                message: "Error creating history",
            });
            toast.info("Creada Correctamente", { theme: "colored", toastId: "create_admin" });
            dispatch(getExcerciseById(exerciseData.exerciseId))
        } catch (error) {
            console.error("Error creating history", error);
        }
    };
};

export const updateHistoryById= (id, historyData, exerciseId) => {
    return async (dispatch) => {
        try {
            const data = await httpRequest({
                method: "put",
                url: `${baseURL}/historys/${id}`,
                data: historyData,
                message: "Error creating history",
            });
            toast.info("Actualizada Correctamente", { theme: "colored", toastId: "uhistory" });
            dispatch(getExcerciseById(exerciseId))
        } catch (error) {
            console.error("Error actualizando history", error);
        }
    };
};

export const deleteHistoryById= (id , exerciseId) => {
    return async (dispatch) => {
        try {
            const data = await httpRequest({
                method: "delete",
                url: `${baseURL}/historys/${id}`,
                message: "Error creating history",
            });
            toast.info("Eliminada Correctamente", { theme: "colored", toastId: "uhistory" });
            dispatch(getExcerciseById(exerciseId))
        } catch (error) {
            console.error("Error eliminando history", error);
        }
    };
};

